import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_EMPLOYEELOCATION,
  DELETE_EMPLOYEELOCATION,
  UPDATE_EMPLOYEELOCATION,
  ADD_NEW_EMPLOYEELOCATION,
} from "./actionType";

import {
  getEmployeeLocationSuccess,
  getEmployeeLocationFail,
  deleteEmployeeLocationSuccess,
  deleteEmployeeLocationFail,
  updateEmployeeLocationSuccess,
  updateEmployeeLocationFail,
  addEmployeeLocationSuccess,
  addEmployeeLocationFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveEmployeeLocationApi,
  getEmployeeLocationApi,
  updateEmployeeLocationApi,
  deleteEmployeeLocationApi,
  addNewEmployeeLocationApi
} from "../../helpers/backend_helper";

function* getEmployeeLocation({ payload: employeeLocation }) {
  try {
    const response = yield call(getEmployeeLocationApi, employeeLocation);
    yield put(getEmployeeLocationSuccess(GET_EMPLOYEELOCATION, response.data));
  } catch (error) {
    yield put(getEmployeeLocationFail(GET_EMPLOYEELOCATION, error));
  }
}

function* onUpdateEmployeeLocation({ payload: employeeLocation }) {
  try {
    if (employeeLocation.setApprove) {
      const response = yield call(approveEmployeeLocationApi, employeeLocation);
      yield put(updateEmployeeLocationSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateEmployeeLocationApi, employeeLocation);
      yield put(updateEmployeeLocationSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateEmployeeLocationFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteEmployeeLocation({ payload: employeeLocation }) {
  try {
    const response = yield call(deleteEmployeeLocationApi, employeeLocation);
    yield put(deleteEmployeeLocationSuccess({ employeeLocation, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteEmployeeLocationFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewEmployeeLocation({ payload: employeeLocation }) {
  try {
    const response = yield call(addNewEmployeeLocationApi, employeeLocation);
    yield put(addEmployeeLocationSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addEmployeeLocationFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetEmployeeLocation() {
  yield takeEvery(GET_EMPLOYEELOCATION, getEmployeeLocation);
}

export function* watchUpdateEmployeeLocation() {
  yield takeEvery(UPDATE_EMPLOYEELOCATION, onUpdateEmployeeLocation);
}

export function* watchDeleteEmployeeLocation() {
  yield takeEvery(DELETE_EMPLOYEELOCATION, onDeleteEmployeeLocation);
}

export function* watchAddNewEmployeeLocation() {
  yield takeEvery(ADD_NEW_EMPLOYEELOCATION, onAddNewEmployeeLocation);
}

function* employeeLocationSaga() {
  yield all([
    fork(watchGetEmployeeLocation),
    fork(watchDeleteEmployeeLocation),
    fork(watchUpdateEmployeeLocation),
    fork(watchAddNewEmployeeLocation)
  ]);
}

export default employeeLocationSaga;
